module.exports = __webpack_public_path__ + "images/emails/activity-6a4a87d3.png";